var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconShareScreen = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4455 4L3.56564 4.00033C3.27649 4.00033 2.99763 4.04958 2.74894 4.20329C2.25189 4.51105 2.00088 4.95797 2.00088 5.54372V17.813C2.00088 17.891 2.00066 17.969 2.00044 18.0471C2 18.2032 1.99956 18.3594 2.00088 18.5154C1.99975 18.8234 2.09785 19.1237 2.28074 19.3719C2.59475 19.8017 3.02581 20 3.55635 20H20.4522C20.982 20 21.4124 19.7947 21.7245 19.365C21.9211 19.0929 22 18.7839 22 18.4487V5.59298C22 5.54075 22 5.48852 21.998 5.43629C21.9906 5.1481 21.8957 4.86892 21.7258 4.63567C21.4118 4.2023 20.9784 4 20.4455 4ZM13.3247 16.6458C13.0408 16.8801 12.8293 17 12.5566 17C12.1837 17 11.9054 16.7275 11.9054 16.3624V14.2807H11.744C9.58998 14.2807 8.22635 14.8147 7.25232 16.5967C7.06308 16.9455 6.80705 17 6.56772 17C6.27273 17 6 16.7384 6 16.2698C6 12.2425 7.74212 9.73025 11.744 9.73025H11.9054V7.6703C11.9054 7.30518 12.1837 7 12.5677 7C12.8387 7 13.0053 7.13449 13.3186 7.38743L13.3247 7.39237L17.7161 11.4142C17.9221 11.6158 18 11.8174 18 12.0027C18 12.1826 17.9221 12.3842 17.7161 12.5858L13.3247 16.6458Z",
    fill: "#878793"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconShareScreen);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-share-screen.b8ae1a1b40e3445789b3886ebea0dc48.svg";